import { Card, CardActionArea, CardContent, useTheme } from "@mui/material";
import React from "react";
import { LabDto } from "../../../../../customer-experience/src/lib/ShiOneClient";
import { LabPracticeTitleData } from "./LabCards";
import { LabsOnDemandIndicator } from "./LabsOnDemandIndicator";
import LabCardHeader from "./LabCardHeader";
import { telemetryProps } from "../../../instrumentation/gtm";

const css = (theme: any) => ({
  cardRoot: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    maxHeight: 180,
    width: 500,
  },
  content: {
    height: "100%",
    zIndex: 1,
  },
  logoContent: {
    marginTop: theme.spacing(0.5),
    paddingBottom: theme.spacing(2),
    height: "inherit",
    paddingTop: "5px",
  },
});

type LabCardProps = Readonly<{
  lab: LabDto;
  isFilteredResult: boolean;
  handleOpenLabDetails: () => void;
  handleSelectLab: (lab: LabDto) => void;
  labPracticeTitleData: LabPracticeTitleData[];
}>;

export default function LabCard({
  lab,
  isFilteredResult,
  handleOpenLabDetails,
  handleSelectLab,
  labPracticeTitleData,
}: LabCardProps) {
  const theme = useTheme();
  const styles = css(theme);
  const practices = lab.practice?.filter((practice) => practice !== "") ?? [];

  return (
    <Card sx={styles.cardRoot}>
      <CardActionArea
        sx={styles.content}
        onClick={() => {
          handleOpenLabDetails();
          handleSelectLab(lab);
        }}
        {...(isFilteredResult
          ? telemetryProps({
              name: "lab_filter_result",
              section: "labs",
              label: lab.productName ?? "",
            })
          : {})}
      >
        {practices.length > 0 ? (
          practices.map((practice) => (
            <LabCardHeader
              key={`${lab.id}-${practice}`}
              practice={practice}
              lab={lab}
              labPracticeTitleData={labPracticeTitleData}
            />
          ))
        ) : (
          <LabCardHeader
            lab={lab}
            labPracticeTitleData={labPracticeTitleData}
          />
        )}
        <CardContent sx={styles.logoContent} style={{ paddingTop: "5px" }}>
          {lab.isOnDemandLab && <LabsOnDemandIndicator />}
        </CardContent>
      </CardActionArea>
    </Card>
  );
}
